import { ApiRequest } from '../../../misc/api-request'
import { RemoteListsState } from './types'

const baseUrl = '/api/'

// todo: rename this store module to remote-lists, see https://app.clickup.com/t/86c13v30b
const state = new RemoteListsState()
state.requests = {
  getCompletionItems: new ApiRequest('getCompletionItems', 'GET', baseUrl),
  getBiologyValues: new ApiRequest('getBiologyValues', 'GET', baseUrl),
  fetchMedicalUnits: new ApiRequest('fetchMedicalUnits', 'GET', baseUrl),
  fetchNamedEntities: new ApiRequest('fetchNamedEntities', 'GET', baseUrl),
  fetchConstants: new ApiRequest('fetchConstants', 'GET', baseUrl),
  fetchDataPresence: new ApiRequest('fetchDataPresence', 'GET', `${baseUrl}stay-search-criteria/presence`),
}

state.facilities = []
state.divisions = []
state.medicalUnits = []
state.namedEntities = []
state.constants = []
state.completionItems = []
state.biologyValues = []
state.hasDrugs = false
state.hasHealthConstantss = false
state.hasBiologyResults = false
state.completionRequest = { fetching: false, error: null, ok: false }
state.medicalUnitsRequest = { fetching: false, error: null, ok: false }
state.constantsRequest = { fetching: false, error: null, ok: false }
state.dataPresenceRequest = { fetching: false, error: null, ok: false }
state.biologyValuesRequest = { fetching: false, error: null, ok: false }

export { state }
